import React, { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { HeartPulse, Lock, AlertTriangle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export const BillingHealth = ({ onChanged }) => {
  const [data, setData] = useState(null);
  const load = () => api.get("/platform/billing-health").then((r) => setData(r.data)).catch(() => setData({ rows: [] }));
  useEffect(() => { load(); }, []);

  const clear = async (c) => {
    if (!window.confirm(`Mark ${c.display_name} as paid and restore service?`)) return;
    try { await api.post(`/platform/companies/${c.id}/clear-past-due`); toast.success("Service restored"); load(); onChanged?.(); }
    catch (e) { toast.error(apiError(e)); }
  };

  if (!data) return null;
  const rows = data.rows;
  return (
    <div className="rounded-2xl border border-border bg-card p-5" data-testid="billing-health">
      <div className="flex items-center gap-2"><HeartPulse className="h-5 w-5 text-primary" /><h2 className="font-head text-lg font-bold">Billing health</h2>
        <span className="ml-auto text-xs text-muted-foreground">{data.grace_days}-day grace before pause</span></div>
      {rows.length === 0 ? (
        <p className="mt-3 flex items-center gap-2 text-sm text-muted-foreground" data-testid="billing-health-empty"><CheckCircle2 className="h-4 w-4 text-secondary" /> Every agency is paid up. No one is past due or paused.</p>
      ) : (
        <div className="mt-3 space-y-2">
          {rows.map((c) => (
            <div key={c.id} data-testid={`billing-health-${c.id}`} className={`flex flex-wrap items-center justify-between gap-3 rounded-xl border p-3 ${c.locked ? "border-rose-300 bg-rose-50" : "border-amber-200 bg-amber-50"}`}>
              <div className="flex items-center gap-3">
                {c.locked ? <Lock className="h-5 w-5 text-rose-700" /> : <AlertTriangle className="h-5 w-5 text-amber-600" />}
                <div>
                  <p className="font-semibold">{c.display_name} <span className="font-mono text-xs text-muted-foreground">/{c.url_slug}</span></p>
                  <p className="text-xs text-muted-foreground">
                    {c.plan || "No plan"} · {c.admins} admin{c.admins === 1 ? "" : "s"}
                    {c.days_past_due != null && <> · past due {c.days_past_due} day{c.days_past_due === 1 ? "" : "s"}</>}
                    {c.warning_sent && <> · warning emailed</>}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span data-testid="billing-health-status" className={`rounded-full px-3 py-1 text-xs font-bold ${c.locked ? "bg-rose-700 text-white" : "bg-amber-500 text-white"}`}>
                  {c.locked ? "PAUSED" : c.days_remaining == null ? "Past due" : `Pauses in ${c.days_remaining} day${c.days_remaining === 1 ? "" : "s"}`}
                </span>
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => clear(c)} data-testid={`restore-${c.id}`}>Mark paid</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
